module.exports = __webpack_public_path__ + "static/img/C4D0011.768ae2f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0011.jpg
// module id = Oh+z
// module chunks = 0